enum CommentGroup {
  ALL = 'ALL',
  WORK_TIME_RECORD = 'WORK_TIME_RECORD',
  WORK_TIME_RECORD_AUTHORIZATION = 'WORK_TIME_RECORD_AUTHORIZATION',
  OVERTIME_WORK = 'OVERTIME_WORK',
  FINANCE = 'FINANCE',
}

export { CommentGroup };
